import { render, staticRenderFns } from "./modal-templates.vue?vue&type=template&id=60d670d2"
import script from "./modal-templates.vue?vue&type=script&lang=js"
export * from "./modal-templates.vue?vue&type=script&lang=js"
import style0 from "./modal-templates.vue?vue&type=style&index=0&id=60d670d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports